// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-container[data-v-f6b23f7e]{\n  margin: 0 100px 0\n}\n", ""]);
// Exports
module.exports = exports;
